import { render, staticRenderFns } from "./tamarapay.vue?vue&type=template&id=5799e979"
import script from "./tamarapay.vue?vue&type=script&lang=js"
export * from "./tamarapay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports